import React, { Component } from 'react';

import Search from './Search';
import Imprint from './Imprint';
import About from './About';
import Content from './Content';
import Main from './Main';
import Nav from './Nav';
import Footer from './Footer';

import Feedback from './Feedback';

import { Router, Route } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import * as routes from '../constants/routes';


var history = createHistory();

// Analytics Middleware
history.listen((location) => {

  const GA_ID = process.env.REACT_APP_GA_APP_ID || ''

  let page = location.pathname.replace('/','');
  if (page===''){page = 'home';}
  let query = location.search.replace('?q=','');

  window.gtag('config', GA_ID, {
    'page_title' : page,
    'page_path': location.pathname+location.search,
    'anonymize_ip': true
  });

  window.heap.track('View '+page, {
    location: location.pathname,
    query: query
  });

  //console.log("pageview", location.pathname, location.search, page, query);
});



class App extends Component {
  render() {
    return (
      <Router history={history}>
        <div id="top" className='d-flex flex-column' style={{minHeight: '100vh'}}>
          <Nav />
          <Route
            exact path={routes.HOME}
            component={() => <Main />}
          />
          <Route
            path={routes.SEARCH}
            component={() => <Search />}
          />
          <Route
            exact path={routes.CONTENT}
            component={() => <Content />}
          />
          <Route
            exact path={routes.ABOUT}
            component={() => <About />}
          />
          <Route
            exact path={routes.IMPRINT}
            component={() => <Imprint />}
          />
          <Footer />
          <Feedback />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js